module.exports = __webpack_public_path__ + "static/media/empty_bookings.b8b19bbd.svg";